/**
 * Convert FormData elements to JSON
 * @param {FormData} formData An object that is an instance of FormData 
 */
module.exports = formData => {
  if (!(formData instanceof FormData)) {
    throw new Error('Expected formData paramater to be an instance of FormData')
  }

  let o = {}
  for (let p of formData.entries()) {
    o[p[0]] = p[1]
  }

  return o
}
